$(function () {
    $('.header-gallery').each(function () {
        new Swiper(this, {
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 2
            },
            loop: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
    });
});